// Build-Zeit-Versionen des Frontend-Stacks, im Info-Overlay angezeigt.
// Wert wird von Vite (define) ersetzt; Typ siehe src/build-info.d.ts.
export const stackVersions = __STACK_VERSIONS__;
